import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { EventPayload } from 'constants/eventOptions';
import { AppsConstants } from '../constants';
import { transformHookResponse } from '../responseTransforms';

export interface IAppHookPayload {
  id: string | null;
  name: string;
  url: string;
  secret: string;
  secretHeader: string;
  appId: string;
  enableSourceEvents: boolean;
  events: EventPayload;
  isActive: boolean;
  isNew?: boolean;
}

export const saveAppHook = (
  { id, name, url, secret, secretHeader, events, isActive, enableSourceEvents }: IAppHookPayload,
  appId: string
): RequestAction => ({
  type: AppsConstants.APP_SAVE_HOOK,
  request: {
    query: gql`
      mutation(
        $id: ID
        $name: String
        $url: String
        $secret: String
        $secretHeader: String
        $appId: ID
        $enableSourceEvents: Boolean
        $events: [AppHookEventPayload]
        $isActive: Boolean
      ) {
        saveAppHook(
          appHook: {
            id: $id
            name: $name
            url: $url
            secret: $secret
            secretHeader: $secretHeader
            enableSourceEvents: $enableSourceEvents
            appId: $appId
            events: $events
            isActive: $isActive
          }
        ) {
          id
          name
          url
          secret
          secretHeader
          appId
          events {
            name
            types
          }
          enableSourceEvents
          isActive
        }
      }
    `,
    variables: { id, name, url, secret, secretHeader, appId, events, isActive, enableSourceEvents },
  },
  meta: {
    mutations: {
      [AppsConstants.APP + appId]: (data, { saveAppHook }) => {
        const transformedHook = transformHookResponse(saveAppHook);
        const existingHooks = data.hooks.map((hook: any) => hook);
        const updatedHooks = id
          ? existingHooks.map((hook: any) => (hook.id === id ? transformedHook : hook))
          : [...existingHooks, transformedHook];
        return {
          ...data,
          hooks: updatedHooks,
        };
      },
    },
  },
});
